<template>
  <div class="main-nav-toggle light d-lg-none" @click="toggleMenu">
    <span class="toggle-bar"></span>
    <span class="toggle-bar"></span>
    <span class="toggle-bar"></span>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'main-nav-toggle',
  computed: {
    ...mapFields({
      menuOpen: 'ui.menuOpen'
    })
  },
  methods: {
    toggleMenu() {
      this.$store.commit('toggleMenu');
    }
  }
};
</script>
